<template>
    <ValidationObserver ref="form">
        <h2 class="profile__title">Personal Information</h2>
        <div class="row mb-5">

            <PortraitEditor @update-avatar="updateAvatar"/>

            <div class="col-md-7">
                <ValidationProvider
                    class="form-group mb-3"
                    name="Stage Name"
                    v-slot="{ errors }"
                    rules="required|latin|min:2|max:100"
                >
                    <label class="form-label">Stage Name*</label>
                    <input
                        type="text"
                        class="form-control pl-4"
                        v-model="basic.stage_name"
                    >

                    <FormError
                        :error="errors[0]"
                        name="Stage Name"
                    ></FormError>
                </ValidationProvider>

                <div class="form-group mb-3">
                    <label for="" class="form-label">Supplemental title</label>
                    <input type="text" class="form-control pl-4" v-model="basic.supplemental_title">
                </div>

                <div class="form-group mb-3">
                    <label for="" class="form-label">Artist Category*</label>

                    <CategoryMultiSelect
                        :options="artistMainCategory"
                        :selected_options="basic.artist_categories"
                        v-model="basic.artist_categories"
                    ></CategoryMultiSelect>

                </div>
                <div class="form-group mb-3" v-if="basic.artist_categories.length > 0">
                    <label for="" class="form-label">Artist Sub Category*</label>
                    <VueMultiSelect
                        :options="artistSubCategory"
                        :selected_options="basic.artist_subcategories"
                        v-model="basic.artist_subcategories"
                    ></VueMultiSelect>
                </div>
            </div>
        </div>
    </ValidationObserver>
</template>

<script>
import {useArtistStore} from "../../stores/ArtistStore";
import PortraitEditor from "../Common/PortaitEditor.vue";
import FormError from "../Common/FormError.vue";
import {mapActions, mapState} from 'pinia'
import CategoryMultiSelect from "../Common/CategoryMultiSelect.vue";
import VueMultiSelect from "../Common/VueMultiSelect.vue";


export default {
    name: "BasicPersonalInfo",
    components: {CategoryMultiSelect, FormError, PortraitEditor, VueMultiSelect},

    mounted() {
        this.dispatchState(this.form);
        this.fetchArtistCategory();
    },

    computed: {
        ...mapState(useArtistStore, {
            basic: 'basic',
            artist: 'artist',
            artistCategory: 'artistCategory',
        }),
        artistMainCategory() {
            return this.artistCategory;
        },
        artistSubCategory() {
            const filteredCategories = this.artistCategory.filter(category =>
                this.basic.artist_categories.includes(String(category.id))
            );

            const subcategories = filteredCategories.flatMap(category => category.child || []);

            return subcategories.length > 0 ? subcategories : null;

        }

    },

    methods: {
        updateAvatar(avatar) {
            this.$emit('update-avatar', avatar);
        },
        ...mapActions(useArtistStore, {
            fetchArtistCategory: 'fetchArtistCategory',
        }),
    },
    watch: {
        basic: {
            handler(state) {
                this.dispatchState(state);
            },
            deep: true
        }
    }
}
</script>

<style scoped>

</style>
